<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N8kGdj/tc-custom/9781460306109.jpg?1740435328315" alt="This image is the cover for the book Warlord's Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warlord's Bride
      </h1>
      <p class="bookDescription body article font2">
        <b>The king of England offers a traitor’s widow to the Welsh warrior who captured her husband in this medieval romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Lady Roslynn knows not what to expect of her future husband, the infamous “Bear of Brecon.” Offered in marriage to the powerful Welsh lord by the king, Roslynn fears the worst. She has no right to hope for a love match, but in her heart the lady dreams of a home and family of her very own.<br/><br/>One look at Lord Madoc of Llanpowell makes her blood run hot. The rugged warrior proves a passionate lover and attentive husband—but too soon turns cold and aloof. And when secrets from Madoc’s past threaten to take him away from his bride, Roslynn knows their future together is at stake. Can she uncover the truth beneath her warlord’s armor and lay siege to his heart?<br/><br/><b>Praise for <i>The Warlord’s Bride</i></b><br/><br/><b>“A colorfully rendered portrait of medieval Wales brimming with charming characters, an enchanting love story and the perfect balance of romance and history.” —<i>Romantic Times</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Moore
      </h2>
      
      <p class="authorDescription body article">Margaret Moore actually began her writing career at the age of eight, when she and a friend would make up stories together. She also loved to read and many years later graduated with a Bachelor of Arts degree in English Literature. After reading a romance by Kathleen Woodiwiss, Margaret took a course in popular fiction writing and through that, found Romance Writers of America. Three years later, in 1991, she sold her first historical romance. And the rest, as they say, is history!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8929671a